import { apiFetch } from "./client";

export interface AdminEvent {
  id: string;
  type: string;
  status: string;
  createdAt: string;
  attemptCount?: number;
  lastError?: string | null;
  payload?: unknown;
}

export interface EventList {
  data: AdminEvent[];
  nextCursor?: string | null;
}

export const listOutboundEvents = (merchantId: string, params: { limit?: number; cursor?: string } = {}) =>
  apiFetch<EventList>(`/admin/merchants/${merchantId}/events/outbound`, {
    query: { limit: params.limit, cursor: params.cursor },
  });

export const listInboundEvents = (merchantId: string, params: { limit?: number; cursor?: string } = {}) =>
  apiFetch<EventList>(`/admin/merchants/${merchantId}/events/inbound`, {
    query: { limit: params.limit, cursor: params.cursor },
  });

export const retryOutboundEvent = (merchantId: string, eventId: string) =>
  apiFetch<{ ok: boolean }>(`/admin/merchants/${merchantId}/events/outbound/${eventId}/retry`, {
    method: "POST",
  });
